/**
 * Curious Salons - Custom Sections JavaScript
 * FAQ Accordion + Scroll Reveal Animations
 */

(function() {
  'use strict';

  /* ===== FAQ Accordion ===== */
  function initFAQAccordion() {
    document.querySelectorAll('.faq__accordion').forEach(function(accordion) {
      // Skip if already initialized
      if (accordion.dataset.initialized) return;
      accordion.dataset.initialized = 'true';

      accordion.addEventListener('click', function(e) {
        var toggle = e.target.closest('[data-faq-toggle]');
        if (!toggle) return;

        var item = toggle.closest('[data-faq-item]');
        var answer = item.querySelector('.faq__answer');
        var isOpen = item.classList.contains('faq__item--open');

        // Close all siblings
        accordion.querySelectorAll('[data-faq-item]').forEach(function(otherItem) {
          if (otherItem !== item && otherItem.classList.contains('faq__item--open')) {
            otherItem.classList.remove('faq__item--open');
            var otherAnswer = otherItem.querySelector('.faq__answer');
            if (otherAnswer) otherAnswer.setAttribute('hidden', '');
            var otherToggle = otherItem.querySelector('[data-faq-toggle]');
            if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current
        if (isOpen) {
          item.classList.remove('faq__item--open');
          answer.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('faq__item--open');
          answer.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ===== Scroll Reveal ===== */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    var revealElements = document.querySelectorAll(
      '.why-buy__card, .trust-badges__item, .reviews__card, .discovery__product-card, .faq__item'
    );

    if (revealElements.length === 0) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    revealElements.forEach(function(el) {
      el.classList.add('scroll-reveal');
      observer.observe(el);
    });
  }

  /* ===== Init ===== */
  function init() {
    initFAQAccordion();
    initScrollReveal();
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', function() {
    initFAQAccordion();
    initScrollReveal();
  });
})();
